/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentPlatformOption
 */
export interface TournamentPlatformOption {
    /**
     * Internal key (e.g., PC, CONSOLE, MOBILE)
     * @type {string}
     * @memberof TournamentPlatformOption
     */
    key: string;
    /**
     * Display label (e.g., "PC", "Console", "Mobile")
     * @type {string}
     * @memberof TournamentPlatformOption
     */
    label: string;
    /**
     * Whether this option is available for selection
     * @type {boolean}
     * @memberof TournamentPlatformOption
     */
    enabled: boolean;
    /**
     * Display order in dropdowns
     * @type {number}
     * @memberof TournamentPlatformOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentPlatformOption interface.
 */
export function instanceOfTournamentPlatformOption(value: object): value is TournamentPlatformOption {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentPlatformOptionFromJSON(json: any): TournamentPlatformOption {
    return TournamentPlatformOptionFromJSONTyped(json, false);
}

export function TournamentPlatformOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPlatformOption {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentPlatformOptionToJSON(json: any): TournamentPlatformOption {
    return TournamentPlatformOptionToJSONTyped(json, false);
}

export function TournamentPlatformOptionToJSONTyped(value?: TournamentPlatformOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

